import FeatureGates from '@atlaskit/feature-gate-js-client';

export const JIRA_PROJECT_BOARD_EXP_NAME = 'jira_project_board_in_confluence';
export const COHORT_KEY = 'cohort';
export const COHORT = {
	VARIATION: 'variation',
	CONTROL: 'control',
	NOT_ENROLLED: 'not-enrolled',
} as const;

export const useJiraProjectBoardExperiment = () => {
	const experimentCohort = FeatureGates.getExperimentValue<string>(
		JIRA_PROJECT_BOARD_EXP_NAME,
		COHORT_KEY,
		COHORT.NOT_ENROLLED,
		{
			fireExperimentExposure: false,
		},
	);

	const isJiraProjectBoardExperimentEnabled = experimentCohort === COHORT.VARIATION;

	return { isJiraProjectBoardExperimentEnabled, experimentCohort };
};
